import React, { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';


interface AdLayoutProps {
  children: ReactNode;
  hideMobileAds?: boolean;
}

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

const TopAdContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  z-index: 5;
  
  @media (max-width: 768px) {
    position: sticky;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
  }
`;

const MobileAdContainer = styled.div`
  display: none;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  
  @media (max-width: 768px) {
    display: block;
    margin: 0.5rem auto;
  }
`;

const SideAdContainer = styled.div`
  display: none;
  
  @media (min-width: 1200px) {
    display: block;
    position: fixed;
    top: 120px;
    right: 0;
    width: 160px;
    height: 600px;
    z-index: 10;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 0 8px;
  }
`;

const InContentAdContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 30px auto;
  padding: 0;
  clear: both; /* Assure que le conteneur est bien séparé du contenu environnant */
  
  @media (max-width: 768px) {
    margin: 15px auto;
  }
`;

/**
 * Composant de mise en page qui intègre les publicités Adsterra sur toutes les pages
 * Optimisé pour les appareils mobiles et desktop avec des formats spécifiques pour mobile
 */
export const AdLayout: React.FC<AdLayoutProps> = ({ children }) => {
  return (
    <LayoutContainer>
      <ContentContainer>
        {/* Contenu de la page */}
        {children}
      </ContentContainer>
    </LayoutContainer>
  );
};
